import React, { useState } from "react";
import CandleStickChart from "./CandleStickChart";
import LineChart from "./LineChart";
import { formatAmount } from "../../../../../../../util/Helpers";

const InstrumentChart = ({quote, history, currency}) => {

    // Retrieve User Chart Preference from Local Storage
    const chartPref = JSON.parse(localStorage.getItem('instrument:chart')) ?? {chart: "lineChart", range: "3m"};

    // Chart Options State
    const [chart, setChart] = useState(chartPref.chart);
    const [range, setRange] = useState(chartPref.range);

    // Switch between LineChart and Candlestick Chart
    const toggleChart = _ => {
        setChart(chart === "lineChart" ? "candleStickChart" : "lineChart");
    }

    // Persist User Chart preference in localstorage
    localStorage.setItem("instrument:chart", JSON.stringify({ chart, range}))

    /* Get date end */
    const dateRange = new Date();
    switch(range){
        case "7d":
            dateRange.setHours(dateRange.getHours() - (24 * 7));
            break;
        case "1m":
            dateRange.setMonth(dateRange.getMonth() - 1);
            break;
        case "3m":
            dateRange.setMonth(dateRange.getMonth() - 3);
            break;
        case "6m":
            dateRange.setMonth(dateRange.getMonth() - 6);
            break;
        case "1y":
            dateRange.setFullYear(dateRange.getFullYear() - 1);
            break;
        case "2y":
            dateRange.setFullYear(dateRange.getFullYear() - 2);
            break;
        default:
    }

    /* Extract Data in the accepted range */
    const data = [];
    for (let i=(history.length - 1); i >= 0; i--){
        if (new Date(history[i]?.date) > dateRange){
            data.unshift(history[i]);
        }
        else{
            break;
        }
    }

    const positiveChange = quote?.priceChange >= 0;

    return <div className="card card-custom gutter-b  card-stretch">
                <div className="card-header h-auto border-0 px-2">
                    {/* <!--begin::Title--> */}
                    <div className="card-title w-100 pt-5">
                        <h3 className="card-label w-100 row pl-4">
                            <span className="h5 pt-2 text-muted font-weight-bolder col-md-4">
                                <span className="h4">{formatAmount(currency, quote?.last?.toFixed(2))}</span>
                                <span className="small font-weight-bold" style={{color: positiveChange ? "#28cc84" : "#ff3547"}}> 
                                    {positiveChange ? " +" : " -"}{formatAmount(currency, Math.abs(quote?.priceChange ?? 0))} ({Math.abs(quote?.priceChangePercent?.toFixed(2) ?? 0)}%)
                                    <i className={`fa fa-caret-${positiveChange ? "up":"down"} ml-2`}  style={{color: positiveChange ? "#28cc84" : "#ff3547"}}></i>
                                </span>
                            </span>
                            <div className="col d-flex align-items-center justify-content-right  justify-content-end pr-0">
									{/* <!--begin::Actions--> */}
                                    <button 
                                        onClick={_ => setRange("7d")}
                                        className={`btn btn-link font-weight-bolder text-decoration-none text-muted btn-hover-text-primary btn-sm ${range === "7d" ? "active" : ""}`}
                                    >
										7D
									</button>
                                    <button 
                                        onClick={_ => setRange("1m")}
                                        className={`btn btn-link font-weight-bolder text-decoration-none text-muted btn-hover-text-primary btn-sm ${range === "1m" ? "active" : ""}`}
                                    >
										1M
									</button>
                                    <button 
                                        onClick={_ => setRange("3m")}
                                        className={`btn btn-link font-weight-bolder text-decoration-none text-muted btn-hover-text-primary btn-sm ${range === "3m" ? "active" : ""}`}
                                    >
										3M
									</button>
                                    <button 
                                        onClick={_ => setRange("6m")}
                                        className={`btn btn-link font-weight-bolder text-decoration-none text-muted btn-hover-text-primary btn-sm ${range === "6m" ? "active" : ""}`}
                                    >
										6M
									</button>
                                    <button 
                                        onClick={_ => setRange("1y")}
                                        className={`btn btn-link font-weight-bolder text-decoration-none text-muted btn-hover-text-primary btn-sm ${range === "1y" ? "active" : ""}`}
                                    >
										1Y
									</button>
                                    <button 
                                        onClick={_ => setRange("2y")}
                                        className={`btn btn-link font-weight-bolder text-decoration-none text-muted btn-hover-text-primary btn-sm mr-5 ${range === "2y" ? "active" : ""}`}
                                    >
										2Y
									</button>
                                    <button
                                        onClick={toggleChart} 
                                        className={`btn border-primary rounded-circle btn-sm btn-icon mr-1 ${chart === "lineChart" ? "btn-white" : "btn-primary"}`}
                                    >
										<i className="flaticon-interface-6"></i>
									</button>
									{/* <!--end::Actions--> */}
								</div>
                            </h3>
                    </div>
                    {/* <!--end::Title--> */}
                </div>
                {/* <!--begin::Body--> */}
                <div className="card-body pt-2 px-1">
                    {/* <!--begin::Item--> */}
                    <div className="d-flex flex-column my-5 px-5">
                        {
                            chart === "lineChart" ? <LineChart data={data} currency={currency} /> : <CandleStickChart data={data} currency={currency} />
                        }
                        
                        
                    </div>
                    {/* <!--end::Item--> */}
                    
                </div>
                {/* <!--end::Body--> */}
            </div>


}

export default InstrumentChart;